export default __webpack_public_path__ + "static/media/switch.10221183.svg";